var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimsSidebarButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35 1.7002H7.65C4.51516 1.7002 2.94774 1.7002 1.97387 2.67407C1 3.64794 1 5.21536 1 8.3502C1 11.485 1 13.0525 1.97387 14.0263C2.94774 15.0002 4.51516 15.0002 7.65 15.0002C10.7848 15.0002 12.3523 15.0002 13.3261 14.0263C14.3 13.0525 14.3 11.485 14.3 8.3502V7.6502",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 3.45C14.9996 4.8031 13.9027 5.9 12.5496 5.9C11.1965 5.9 10.0996 4.8031 10.0996 3.45C10.0996 2.0969 11.1965 1 12.5496 1C13.9027 1 14.9996 2.0969 14.9996 3.45Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.2998H7.3",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.7998H10.1",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsSidebarButton);
export default __webpack_public_path__ + "static/media/claims-sidebar-button.a6e9fde613c96ae8fc192ec67ef919bd.svg";
export { ForwardRef as ReactComponent };